import { RollbackOutlined } from '@ant-design/icons'
import { usePartners } from '@entities/partner'
import { useCurrentUser } from '@entities/user/model/hooks/use-current-user'
import { dateToString } from '@shared/lib/dateToString/dateToString'
import type { TabsProps } from 'antd'
import { Avatar, Button, Card, Divider, Flex, Space, Tabs, Typography } from 'antd'
import { useNavigate } from 'react-router-dom'
import { AdvertisingPlatforms } from './advertising-platforms'
import { MainForm } from './main-form'
import { OrdForm } from './ord-form'
const { Title, Text } = Typography

export const ProfilePage = () => {
    const navigate = useNavigate()

    const { user } = useCurrentUser()

    const { currentPartner } = usePartners({ id: user?.partnerId })

    const items: TabsProps['items'] = [
        {
            key: '1',
            label: 'Основная информация',
            children: currentPartner ? <MainForm partner={currentPartner} /> : undefined
        },
        {
            key: '2',
            label: 'Рекламные ресурсы',
            children: currentPartner ? <AdvertisingPlatforms partner={currentPartner} /> : undefined
        },
        {
            key: '3',
            label: 'ОРД',
            children: currentPartner ? <OrdForm partner={currentPartner} /> : undefined
        }
    ]

    return (
        <Card>
            <Flex justify="space-between" align="center" style={{ marginBottom: '16px' }}>
                <Title level={3}>Профиль</Title>
                <Button type="primary" onClick={() => navigate(-1)}>
                    Назад <RollbackOutlined />
                </Button>
            </Flex>
            <Flex justify="space-between" align="center">
                <Space size={20} align="start">
                    <Avatar shape="circle" size={100} src={currentPartner?.photoUrl} />
                    <Flex vertical={true} gap={6}>
                        <Title level={4} style={{ margin: 0 }}>
                            {currentPartner?.name}
                        </Title>

                        <Text italic>{currentPartner?.tgUsername}</Text>

                        <Text>{currentPartner?.email}</Text>
                        <Text>{currentPartner?.phone}</Text>
                    </Flex>
                </Space>
                <Flex vertical gap={16} align="flex-end">
                    <Text>
                        Добавлен {currentPartner?.createdAt ? dateToString(currentPartner?.createdAt) : undefined}
                    </Text>
                </Flex>
            </Flex>

            <Divider />
            <Tabs defaultActiveKey="1" items={items} />
        </Card>
    )
}
